import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MinimalShellComponent } from './layout/shells/minimal-shell/minimal-shell.component';
import { MainShellComponent } from './layout/shells/main-shell/main-shell.component';

import { authGuard } from './core/guards/auth.guard';
import { NavbarShellComponent } from './layout/shells/navbar-shell/navbar-shell.component';
import { ActaExpedienteComponent } from './features/expedientes/pages/actas/acta-exp/acta-exp.component';
import { CalculoDerechoComponent } from './features/expedientes/pages/actas/calculo-dererecho/calculo-derecho.component';
import { CalculoAportesComponent } from './features/expedientes/pages/actas/calculo-aportes/calculo-aportes.component';
import { serviceStatusGuard } from './core/guards/service-status';

export const routes: Routes = [
  // 1) Shell mínimo: solo router-outlet (login)
  {
    path: 'login',
    title: 'SmartDOM - Iniciar sesión',
    component: MinimalShellComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/login/login.component').then((c) => c.LoginComponent),
      },
    ],
  }, {
    path: 'registro',
    title: 'SmartDOM - Crear cuenta',
    component: MinimalShellComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/new-user/new-user.component').then(
            (c) => c.NewUserComponent
          ),
      },
    ],
  },
  {
    path: 'recuperar-contrasena',
    title: 'SmartDOM - Recuperar contraseña',
    component: MinimalShellComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/forgot-password/forgot-password.component').then(
            (c) => c.ForgotPasswordComponent
          ),
      }
    ],
  },
  {
    path: 'completar-registro',
    title: 'SmartDOM - Completar registro',
    component: MinimalShellComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/new-user-no-pass-mongo/new-user-no-pass-mongo.component').then(
            (c) => c.NewUserNoPassMongoComponent
          ),
      }
    ],
  },
  {
    path: 'nueva-contrasena',
    title: 'SmartDOM - Nueva contraseña',
    component: MinimalShellComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/new-password/new-password.component').then(
            (c) => c.NewPasswordComponent
          ),
      },
    ],
  },
  {
    path: '',
    title: 'SmartDOM - Servicios',
    component: MainShellComponent,
    canActivate: [authGuard, serviceStatusGuard],
    children: [
      {
        path: '',
        title: 'SmartDOM - Servicios',
        loadComponent: () =>
          import('./pages/home-services/home-services.component').then(
            (c) => c.HomeServicesComponent
          ),
        children: [
          {
            path: 'consultas',
            title: 'SmartDOM - Mesón Online',
            loadComponent: () => import('./features/consultas/pages/meson-online/meson-online.component').then(c => c.MesonOnlineComponent),
          },
          {
            path: 'normativas',
            title: 'SmartDOM - Normativas',
            loadComponent: () => import('./features/normativa/pages/normativa/normativa.component').then(c => c.NormativaComponent),
          },
        ]
      },
      {
        path: 'expedientes',
        title: 'SmartDOM - Expedientes',
        loadChildren: () =>
          import('./features/expedientes/expedientes.module').then(
            (m) => m.ExpedientesModule
          ),
      },
      {
        path: 'certificados',
        title: 'SmartDOM - Certificados',
        loadChildren: () =>
          import('./features/certificados/certificados.module').then(
            (m) => m.CertificadosModule
          ),
      },
      {
        path: 'inspeccion',
        title: 'SmartDOM - Inspección',
        loadChildren: () =>
          import('./features/inspeccion/inspeccion.module').then(
            (m) => m.InspeccionModule
          ),
      },
      {
        path: "observaciones",
        title: 'SmartDOM - Observaciones',
        loadChildren: () =>
          import("./features/observaciones/observaciones.module").then(
            (m) => m.ObservacionesModule
          ),
      },
      {
        path: "pago",
        title: 'SmartDOM - Pagos',
        loadChildren: () =>
          import("./features/pagos/pagos.module").then(
            (m) => m.PagosModule
          ),
      },
      {
        path: 'totem',
        title: 'SmartDOM - Tótem',
        loadChildren: () =>
          import('./features/totem/totem.module').then(
            (m) => m.TotemModule
          ),
      },
      {
        path: 'perfil',
        title: 'SmartDOM - Perfil',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/user-profile/user-profile.component').then(
                (c) => c.UserProfileComponent
              ),
          },
        ],
      }
    ],
  },
  // Verificación pública de documentos (sin auth)
  {
    path: 'verificacion',
    component: MainShellComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/verificacion/verificacion.component').then(
            (c) => c.VerificacionComponent
          ),
      },
      {
        path: ':code',
        loadComponent: () =>
          import('./features/verificacion/verificacion.component').then(
            (c) => c.VerificacionComponent
          ),
      },
    ],
  },
  //PDF o Actas
  {
    path: 'acta-expediente',
    component: MinimalShellComponent,
    canActivate: [authGuard],
    children: [{ path: '', component: ActaExpedienteComponent }],
  }, {
    path: 'calculo-derecho',
    component: MinimalShellComponent,
    canActivate: [authGuard],
    children: [{ path: '', component: CalculoDerechoComponent }],
  }, {
    path: 'calculo-aportes',
    component: MinimalShellComponent,
    canActivate: [authGuard],
    children: [{ path: '', component: CalculoAportesComponent }],
  },
  // 🔹 Fallback
  {
    path: '**',
    title: 'SmartDOM - No encontrado',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(
        (c) => c.NotFoundComponent
      ),
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
